import React, { useReducer } from "react";
import PropTypes from "prop-types";

// Set up our reducer function to act on Previous and Next selections
function reducer(state, action) {
    switch (action.type) {
        case "ActionWindowsDto":
            return {
                ...state,
                actionWindowsDto: action.actionWindowsDto
            };
        case "AllLocationDtos":
            return {
                ...state,
                allLocationDtos: action.allLocationDtos
            };
        case "CurrentTimePeriodDto":
            return {
                ...state,
                currentTimePeriodDto: action.currentTimePeriodDto
            };
        case "DistrictTemplateDto":
            return {
                ...state,
                districtTemplateDto: action.districtTemplateDto
            };
        case "EprActionWindows":
            return {
                ...state,
                eprActionWindows: action.eprActionWindows
            };
        case "EprGradingProfiles":
            return {
                ...state,
                eprGradingProfiles: action.eprGradingProfiles
            };
        case "EprResources":
            return {
                ...state,
                eprResources: action.eprResources
            };
        case "EprStudentImage":
            return {
                ...state,
                eprStudentImage: action.eprStudentImage
            };
        case "Guid":
            return {
                ...state,
                guid: action.guid
            };
        case "IsDistrictViewingSchool":
            return {
                ...state,
                isDistrictViewingSchool: action.isDistrictViewingSchool
            };
        case "Lang":
            return {
                ...state,
                lang: action.lang
            };
        case "LegacyLocationDtos":
            return {
                ...state,
                legacyLocationDtos: action.legacyLocationDtos
            };
        case "LocationDto":
            return {
                ...state,
                locationDto: action.locationDto
            };
        case "SchoolLevelTemplateDto":
            return {
                ...state,
                schoolLevelTemplateDto: action.schoolLevelTemplateDto
            };
        case "SchoolTemplatesByLocationMerge":
            return {
                ...state,
                schoolTemplatesByLocation: {
                    ...(state.schoolTemplatesByLocation || {}),
                    ...action.schoolTemplatesByLocation
                }
            };

        case "SchoolTemplatesLoadingByLocationMerge":
            return {
                ...state,
                schoolTemplatesLoadingByLocation: {
                    ...(state.schoolTemplatesLoadingByLocation || {}),
                    ...action.schoolTemplatesLoadingByLocation
                }
            };

        case "SchoolYearDto":
            return {
                ...state,
                schoolYearDto: action.schoolYearDto
            };
        case "StudentImageList":
            return {
                ...state,
                studentImageList: action.studentImageList
            };
        case "StudentsIc":
            return {
                ...state,
                studentsIc: action.studentsIc
            };
        case "TimePeriodDto":
            return {
                ...state,
                timePeriodDto: action.timePeriodDto
            };
        case "Token":
            return {
                ...state,
                token: action.token
            };
        case "UserDetails":
            return {
                ...state,
                userDetails: action.userDetails
            };
        case "Username":
            return {
                ...state,
                username: action.username
            };
        case "ViewTimePeriodDto":
            return {
                ...state,
                viewTimePeriodDto: action.viewTimePeriodDto
            };
        default:
            return { token: null };
    }
}

// Set the count to 0
const initialState = { token: null, username: null };
// Create a counter context, initially storing the initialState
const GlobalContext = React.createContext(initialState);
// Create a counter-provider to pass down the
const ContextProvider = ({ children }) => {
    const [state, dispatch] = useReducer(reducer, initialState);
    return (
        /**
         * Pass an object with the current state and dispatch values as props
         * to the context provider and allow all children of <CounterProvider/>
         * component to have these context values
         */
        // eslint-disable-next-line react/jsx-no-constructed-context-values
        <GlobalContext.Provider value={{ state, dispatch }}>{children}</GlobalContext.Provider>
    );
};

ContextProvider.propTypes = {
    children: PropTypes.node
};

ContextProvider.defaultProps = {
    children: null
};

export { GlobalContext, ContextProvider };
